<template >
    <transition name="fade" mode="out-in">
        <div>
            <ul class="submenu-sections" v-if="!isLoadingDayTemplate && currentDayTemplate">
                <router-link tag="li" :to="{name:'DayTemplateDetails', params:{dayTemplateUid:params.dayTemplateUid}}">
                    <a><h4><span class="text">{{Translations.sections.dayTemplates.details.menu.schedule}}</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'DayTemplateAdBreaks', params:{dayTemplateUid:params.dayTemplateUid}}">
                    <a><h4><span class="text">{{Translations.sections.dayTemplates.details.menu.adBreaks}}</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'DayTemplateConstraints', params:{dayTemplateUid:params.dayTemplateUid}}">
                    <a><h4><span class="text">
                        {{Translations.sections.dayTemplates.details.menu.constraints}}
                    </span></h4></a>
                </router-link>
            </ul>
        </div>
    </transition>
</template>
<script >
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Translations from '@/store/translations';

    export default {
        name: "DayTemplateMenu",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            params: function() { return this.$route.params; },
            ...mapState(
                ["currentDayTemplate", "isLoadingDayTemplate"]),
        },
    }
</script>

<style scoped>
</style>
